import { render, staticRenderFns } from "./FinalReportInvoicesGeneralDataRowComparison.vue?vue&type=template&id=0d1e808c&scoped=true&"
import script from "./FinalReportInvoicesGeneralDataRowComparison.vue?vue&type=script&lang=js&"
export * from "./FinalReportInvoicesGeneralDataRowComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1e808c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VLayout})
